import React, { useState, useContext } from "react";
import { Card, Modal } from "antd";
import { FormattedMessage } from "react-intl";
import { SaveOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";

import OtherSectionFormItem from "./OtherSectionFormItem";

import { FormV5Context } from "../../NodeChannelFormV5";

import useNodeChannelConfig from "../../../../hooks/useNodeChannelConfig";

import EnginePlayoutElement from "../../../EnginePlayoutElement";

export default function OtherSection({ disabled, handleFinish }) {
  const [open, setOpen] = useState(false);
  const form = useContext(FormV5Context);

  const { channelConfig, other } = useNodeChannelConfig();

  const { resetFields, getFieldValue } = form;

  const handleSaveOther = () => {
    const formData = getFieldValue("other");
    handleFinish({ ...channelConfig, other: formData });
    setOpen(false);
  };

  return (
    <Card title={<FormattedMessage id="OtherSection.other" defaultMessage="Other" />}>
      <EnginePlayoutElement
        label={<FormattedMessage id="OtherSection.other" defaultMessage="Other" />}
        handleClick={() => setOpen(true)}
        data={other}
      />
      <Modal
        title={<FormattedMessage id="OtherSection.other" defaultMessage="Other" />}
        centered
        destroyOnClose
        open={open}
        onCancel={() => {
          resetFields();
          setOpen(false);
        }}
        onOk={handleSaveOther}
        width={1280}
        footer={disabled ? null : undefined}
        okText={
          <span>
            <FormattedMessage id="general.save" defaultMessage="Save" />
          </span>
        }
        okButtonProps={{ icon: <SaveOutlined /> }}
      >
        <OtherSectionFormItem prefix={["other"]} disabled={disabled} />
      </Modal>
    </Card>
  );
}

OtherSection.propTypes = {
  disabled: PropTypes.bool.isRequired,
  handleFinish: PropTypes.func.isRequired,
};
